export const FEATURE_NAME = '@zerops/zerops/feature/http-routing-edit-dialog';
